interface TreeItem {
  menuItemId: string
  internalTargetId: string
  subitems: TreeItem[]
}

export function findActiveTrail({ id, subTree }: { id: string, subTree: TreeItem[]}) {
  for (const item of subTree) {
    // Look deeper
    if (item.subitems) {
      const subTreeResult = findActiveTrail({
        id,
        subTree: item.subitems,
      })
      if (subTreeResult.length) {
        // Target found in subitems, bubble up.
        return [item.menuItemId, ...subTreeResult].filter(Boolean)
      }
    }

    // Found the target
    if (item.menuItemId && item.internalTargetId === id) {
      return [item.menuItemId]
    }
  }

  return []
}
